import {
  Slider,
  SliderFilledTrack,
  SliderProps,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react';

const CustomSlider = (props: SliderProps): JSX.Element => (
  <Slider {...props}>
    <SliderTrack bg="slider.track" height="4px" overflow="visible">
      <SliderFilledTrack
        borderRadius="20px"
        bg="slider.filledTrack"
        height="6px"
      />
    </SliderTrack>
    <SliderThumb
      boxSize={5}
      shadow={0}
      bg="custom.levoYellow"
      _focus={{ boxShadow: '0 0 0 6px #FDDA0533' }}
    />
  </Slider>
);

export default CustomSlider;
